import request from "../utils/request"

function readyz() {
  return request({
    url: 'v1/readyz',
    method: 'GET',
  })
}

//APP下载图片
function app() {
  return request({
    url: "metadata/app",
    method: "GET"
  })
}

//首页幻灯片
function slides() {
  return request({
    url: "metadata/slides",
    method: "GET"
  })
}

//信徒圣诗赞美
function witnessGrace(pageNo, pageSize) {
  return request({
    url: `subjects/witnessGrace?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: "GET"
  })
}

// 信徒圣诗赞美——专辑基本信息
function albums(id) {
  return request({
    url: "albums",
    method: "GET",
    data: id
  })
}

//圣剧欣赏
function poems(pageNo, pageSize) {
  return request({
    url: `subjects/poems?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: "GET"
  })
}

//圣诗圣剧欣赏——专辑基本信息
function sjalbums(id) {
  return request({
    url: "api/albums",
    method: "GET",
    data: id
  })
}

//日常证道
function preach(pageNo, pageSize) {
  return request({
    url: `subjects/preach?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: "GET"
  })
}

//查经系列
function witness(pageNo, pageSize) {
  return request({
    url: `subjects/witness?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: "GET"
  })
}

//专题证道
function praise(pageNo, pageSize) {
  return request({
    url: `subjects/praise?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: "GET"
  })
}

//信仰简介
function abouts(pageNo, pageSize) {
  return request({
    url: `subjects/abouts?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: "GET"
  })
}

//教堂简介
function beliefs(pageNo, pageSize) {
  return request({
    url: `subjects/beliefs?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: "GET"
  })
}

//生命见证
function ministries(pageNo, pageSize) {
  return request({
    url: `subjects/ministries?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: "GET"
  })
}

//事工团契
function fellowships(pageNo, pageSize) {
  return request({
    url: `subjects/fellowships?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: "GET"
  })
}

//事工团契
function download(pageNo, pageSize) {
  return request({
    url: `resources/download?pageNo=${pageNo}&pageSize=${pageSize}`,
    method: "GET"
  })
}

//聚会时间表
function jtime() {
  return request({
    url: "metadata/worshiptime",
    method: "GET"
  })
}

//直播时间
function ztime() {
  return request({
    url: "metadata/livetime",
    method: "GET"
  })
}

//登陆验证图片
// function yimage(){
//     return request({
//         url:"image",
//         method:"GET"
//     })
// }

//系统信息
function notics() {
  return request({
    url: "notices",
    method: "GET"
  })
}

//齐来崇拜图片
function qlcb() {
  return request({
    url: "metadata/worshipthumb",
    method: "GET"
  })
}

function getyz(data) {
  return request({
    url: "https://www.jnccljh.com/api/sms",
    method: "POST",
    data: data
  })
}

function searches(data) {
  return request({
    url: "https://www.jnccljh.com/api/searches",
    method: "POST",
    data: data
  })
}

export {
  readyz,
  app,
  slides,
  witnessGrace,
  poems,
  sjalbums,
  preach,
  witness,
  praise,
  abouts,
  beliefs,
  ministries,
  fellowships,
  download,
  jtime,
  ztime,
  notics,
  qlcb,
  getyz,
  searches
}



// WEBPACK FOOTER //
// ./src/api/index.js